import { BASE_PATH } from '../../env'

export const getImagePath = (key: string): string => [BASE_PATH, 'images', key].join('/')
